import React, {useState} from "react";
import storeFolder from '../../../../../store';
import { UserIconsPic } from "Components/UBMeEvents/Components_UBMeEvents/Navbar/Alphabets/UserIconsPic";
import {Modal, TablePagination} from "@material-ui/core";
import { LazyLoadImage } from "react-lazy-load-image-component";
import IconButton from '@material-ui/core/IconButton';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Card from "../../../../../Helper/CardWrapper/cardWrapper";
import WebView from "../../../Messages/WebView";
import {connect} from "react-redux";
import {
  CreateShoppingCartSession,
  GetAllOrderFormFieldsByEventId,
  PersistShoppingCartSession
} from "../../../../../Actions/eventActions";
import {removeEmptyDialog, selectedChat} from "../../../../../Actions/messagesAction";
import CloseIcon from "@material-ui/icons/Close";

function ActiveAttendee({
                          checkedInUsersList,
                          dispatch,
                          results,
                          removeEmptyDialog,
                          messageData,
}) {

  const [userMessagesModalIsOpen, setUserMessagesModalIsOpen] = useState(false);
  const [userMessages, setUserMessages] = useState({});

  const userMessagesModal = (data) => {
    if (data !== null) {
      const userId = results?.ProfileDetail?.UserId;
      let selectedChatIndex = -1;
      if (userMessagesModalIsOpen && messageData) {
        messageData?.recentChat?.forEach((message, index) => {
          if (data.UserId + "" === message.userid && message.Type !== "PlaceQuestionChat") {
            selectedChatIndex = index;
          }
        });
      }

      let showInfo = false;
      const organizerFirstName = data.FullName ? data.FullName : '';
      // const organizerProfileImage = data.OrginizerDetails ? data.OrginizerDetails.ProfileImage : '';

      return (
          <Modal
              open={userMessagesModalIsOpen}
              onClose={() => closeUserMessagesModal(data)}
          >
            <Card
                CardContentProps={{
                  style: userMessagesModalStyles(),
                }}
                content={
                  <>
                    <IconButton
                        style={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          zIndex: 1
                        }}
                        onClick={() => closeUserMessagesModal(data)}
                    >
                      <CloseIcon />
                    </IconButton>
                    <WebView
                        userId={userId}
                        updateState={updateState}
                        // toggleAlert={this.toggleAlert}
                        showInfo={showInfo}
                        curbsideCommunication={true}
                        curbsideCommunicationUserData={{
                          FullName: organizerFirstName,
                          // ProfileImage: organizerProfileImage,
                          // UserName: data.UserName,
                          UserId: data.UserId,
                        }}
                        curbsideCommunicationSelectedChatIndex={selectedChatIndex}
                    />
                  </>
                }
            />
          </Modal>
      );
    }
  };

  const showUserMessagesModal = (data) => {
    setUserMessages(data);
    setUserMessagesModalIsOpen(true);
  };

  const closeUserMessagesModal = (data) => {
    if (messageData?.selectedChat?.last_message_json &&
        Object.keys(messageData.selectedChat.last_message_json).length === 0) {
      removeEmptyDialog(data);
    }
    localStorage.removeItem("curbsideCommunicationUserId");
    localStorage.removeItem("curbsideCommunicationUserName");
    localStorage.removeItem("curbsideCommunicationFullName");
    localStorage.removeItem("curbsideCommunicationProfileImage");
    localStorage.removeItem("pendingEventsButtonClick");

    setUserMessagesModalIsOpen(false);
    setUserMessages({});
  };

  const userMessagesModalStyles = () => {
    return {
      position: "fixed",
      top: window.screen.Height < 1100 ? "10%" : "5%",
      width:
          window.screen.width < 1100
              ? window.screen.width < 850
                  ? "84%"
                  : "55%"
              : "",
      left:
          window.screen.width < 1100
              ? window.screen.width < 850
                  ? "8%"
                  : "22%"
              : "30%",
      right:
          window.screen.width < 1100
              ? window.screen.width < 850
                  ? "8%"
                  : "22%"
              : "30%",
      borderRadius: "8px",
      backgroundColor: "white",
      maxHeight: "80vh", // Set a maximum height for the card
      overflowY: "auto", // Enable vertical scrolling
    };
  };

  const updateState = (state, value) => {
    this.setState({
      [state]: value,
    });
  };

  let parsedData = [];
  let storeData = storeFolder.getState();
  const eventDetails = localStorage.getItem("UserId")
  // Check if checkedInUsersList is a non-empty string before parsing
  if (checkedInUsersList && typeof checkedInUsersList === 'string' && checkedInUsersList.trim() !== '') {
    try {
      parsedData = JSON.parse(checkedInUsersList);
    } catch (error) {
      // Handle the JSON parsing error
      console.error("Error parsing JSON:", error);
    }
  }

  return (
    <div className="activeAttendees">
      {checkedInUsersList.length ?
        (
          <>
            {
             checkedInUsersList?.filter((item) => item.User_ID == eventDetails).map((item, idx) => {
                return (
                  <div key={idx} className="activeAttendee">

                    <LazyLoadImage
                      src={
                        item?.Photo === null || item?.Photo === ""
                          ? UserIconsPic(item?.First_Name?.[0]?.toUpperCase())
                          : `https://ubme-cdn-ahaqgmczced0ejda.z03.azurefd.net/ubme-com/UploadImages/AppUserProfileImages/ProfileOriginalImage/${item?.Photo}`
                      }
                      alt=""
                      // effect="blur"
                    />
                    <div className="userDetail">
                      <h2 style={{ marginBottom: "10px", color: eventDetails == item?.User_ID ? "#a740b3" : "black" }}>{item?.First_Name}</h2>
                      <p style={{ color: "black" }}>@{item?.UserName}</p>
                    </div>
                  </div>
                )
              })
            }
            {checkedInUsersList?.sort((a, b) => {
              const timeA = new Date(a.CheckInDate)
              const timeB = new Date(b.CheckInDate)

              return timeB - timeA;
            }).filter((item) => item.User_ID != eventDetails).map((item, idx) => (
              <div key={idx} className="activeAttendee">
                <LazyLoadImage
                  src={
                    item.Photo === null || item.Photo === ""
                      ? UserIconsPic(item.First_Name[0]?.toUpperCase())
                      : `https://ubme-cdn-ahaqgmczced0ejda.z03.azurefd.net/ubme-com/UploadImages/AppUserProfileImages/ProfileOriginalImage/${item.Photo}`
                  }
                  alt=""
                  // effect="blur"
                  // onClick={()=>{onContactClick()
                  //   setUserData(item);
                  // }}
                />
                <div className="userDetail">
                  <h2 style={{ marginBottom: "10px", color: eventDetails == item?.User_ID ? "#a740b3" : "black" }}>{item.First_Name}</h2>
                  <p style={{ color: "black" }}>@{item.UserName}</p>
                </div>
                <div className="messageIcon">
                  <span className="participant-message-button-space"></span>
                  {
                    // data.lastMessageFromUserId > 0 && props.user.UserId === data.lastMessageFromUserId
                    //     ?
                    //     <IconButton onClick={() => props.showUserMessagesModal(data)}>
                    //       <img src={require('../../../images/mail_replied.png')} className="herenow-message-reply-button"/>
                    //     </IconButton>
                    //     :
                    // onClick={() => props.showUserMessagesModal(data)}
                    <IconButton onClick={() => showUserMessagesModal(item)}>
                      <MailOutlineIcon className="participant-message-button" fontSize="large"/>
                    </IconButton>
                  }
                </div>
              </div>
            ))}
            {userMessagesModalIsOpen ? userMessagesModal(userMessages) : null}
          </>
        )
      : (
        // <>{refresh ? (
        //   <>
        //     {
        //     storeData.eventReducer?.checkedInUsersList.filter((item) => item.User_ID == eventDetails).map((item, idx) => {
        //       return (
        //         <div key={idx} className="activeAttendee">
        //           <img
        //             src={
        //               item.Photo === null || item.Photo === ""
        //                 ? UserIconsPic(item.First_Name[0]?.toUpperCase())
        //                 : `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${item.Photo}`
        //             }
        //             alt=""
        //           />
        //           <div className="userDetail">
        //             <h2 style={{ marginBottom: "10px", color: eventDetails == item?.User_ID ? "#a740b3" : "black" }}>{item.First_Name}</h2>
        //             <p style={{ color: "black" }}>@{item.UserName}</p>
        //           </div>
        //         </div>
        //       )
        //     })
        //   }
        //   {storeData.eventReducer?.checkedInUsersList.sort((a, b) => {
        //     const timeA = new Date(a.CheckInDate)
        //     const timeB = new Date(b.CheckInDate)

        //     return timeB - timeA;
        //   }).filter((item) => item.User_ID != eventDetails).map((item, idx) => (
        //     <div key={idx} className="activeAttendee">
        //       <img
        //         src={
        //           item.Photo === null || item.Photo === ""
        //             ? UserIconsPic(item.First_Name[0]?.toUpperCase())
        //             : `https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${item.Photo}`
        //         }
        //         alt=""
        //         // onClick={()=>{onContactClick()
        //         //   setUserData(item);
        //         // }}
        //       />
        //       <div className="userDetail">
        //         <h2 style={{ marginBottom: "10px", color: eventDetails == item?.User_ID ? "#a740b3" : "black" }}>{item.First_Name}</h2>
        //         <p style={{ color: "black" }}>@{item.UserName}</p>
        //       </div>
        //     </div>
        //   ))}
        //   </>
        // ):"No user online"}
        // </>
        <div>
          No user online
        </div>
      )}

    </div>

  );
}

const mapStateToProps = (state) => {
  const { eventUserEvents } = state;
  return {
    results: state.loginResponse.results,
    messageData: state.messageReducer,
  };
};

const matchDispatchToProps = (dispatch) => {
  return {
    removeEmptyDialog,
    selectedChat,
    dispatch,
  };
};

export default connect(mapStateToProps, matchDispatchToProps) (ActiveAttendee);
